export default "__VITE_ASSET__DfD4bKD8__"